module.exports = __webpack_public_path__ + "img/9-half-lg.3a4e235c.jpg";